import { Node, mergeAttributes } from '@tiptap/core';

// Self-hosted <video> node
export const Video = Node.create({
  name: 'video',
  group: 'block',
  atom: true,
  draggable: true,
  addAttributes() {
    return {
      src: { default: null },
      controls: { default: true },
    };
  },
  parseHTML() {
    return [{ tag: 'video[src]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['video', mergeAttributes(HTMLAttributes, {
      controls: 'true',
      class: 'w-full rounded-lg my-3',
    })];
  },
  addCommands() {
    return {
      setVideo: (options) => ({ commands }) =>
        commands.insertContent({ type: this.name, attrs: options }),
    };
  },
});

// Convert a YouTube/Vimeo URL into an embeddable src
export const toEmbedUrl = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return null;
};

// YouTube/Vimeo <iframe> embed node
export const Embed = Node.create({
  name: 'embed',
  group: 'block',
  atom: true,
  draggable: true,
  addAttributes() {
    return { src: { default: null } };
  },
  parseHTML() {
    return [{ tag: 'iframe[src]' }];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      { class: 'video-embed relative my-3', style: 'position:relative;padding-bottom:56.25%;height:0;overflow:hidden;border-radius:0.5rem;' },
      ['iframe', mergeAttributes(HTMLAttributes, {
        frameborder: '0',
        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
        allowfullscreen: 'true',
        style: 'position:absolute;top:0;left:0;width:100%;height:100%;',
      })],
    ];
  },
  addCommands() {
    return {
      setEmbed: (options) => ({ commands }) =>
        commands.insertContent({ type: this.name, attrs: options }),
    };
  },
});
